<template>
  <nav
    v-if="data.length"
    class="page-filter page-filter__up"
    :class="{'page-filter--list': list, 'custom-scrollbar': !isTouch, 'page-filter--without-container': withoutContainer}"
  >
    <ul class="page-filter__list">
      <li
        @click="handleClick(item)"
        v-for="item in computedFilters"
        :key="item.id"
        class="page-filter__item"
        :class="{'active': activeId === item.id}"
      >
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
import { isTouch } from '../../../mixins/isTouchDevice'

export default {
  name: 'CategoryFilter',
  mixins: [isTouch],
  data () {
    return {
      activeId: null
    }
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    list: {
      type: Boolean,
      default: false
    },
    withoutContainer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedFilters () {
      if (this.data.length && !this.list) {
        return [ { name: this.$t('category_filter_all_products'), id: null }, ...this.data ]
      }

      if (this.data.length) return this.data

      return []
    }
  },
  methods: {
    handleClick (item) {
      this.activeId = item.id

      const emitData = {
        id: +item.id,
        link: item.link
      }

      this.$emit('change-filter', emitData)
    }
  },
  mounted () {
    if (this.data.length && this.list) this.handleClick(this.data[0])
  }
}
</script>

<style scoped lang="sass">

.page-filter
  overflow: auto

.page-filter__list
  flex-flow: row nowrap

  +mmin($tablet)
    flex-flow: row wrap

.page-filter__item
  cursor: pointer
  font-size: 14px
  margin-bottom: 20px
  flex-shrink: 0
  display: flex

.page-filter--without-container
  padding: 0 15px
  margin: 0 -15px

  +mmin($tablet)
    padding: 0
    margin: 0

.page-filter--list
  margin: 0 0 20px

  +mmin($tablet--hor)
    width: 25%
    margin: 0

  .page-filter__list
    display: flex
    padding: 0 15px
    flex-flow: row nowrap

    +mmin($tablet--hor)
      flex-flow: column
      padding: 25px 20px
      border-top: 1px solid #f3f3f3

  .page-filter__item

    span
      +mmin($tablet--hor)
        padding: 0

    &:hover
      border-color: $main-color

    +mmin($tablet--hor)
      flex-shrink: 0
      padding: 11px 20px
      text-align: left
      margin: 0 0 -1px
      border-color: transparent

.active
  pointer-events: none
  border-color: $main-color
</style>
